import React from 'react';
import { Badge, Button, NumberInput } from '@onward-delivery/design';
import { ALLOCATION_MODES } from './constants';
import { draftKey, sellableLabel } from './utils';

// No class-merge helper exists in this repo and the design package does not
// export one, so compose the className directly.
const ProductRow = ({ row, line, mode, onAdd, onQtyChange }) => {
    const serialized = mode === ALLOCATION_MODES.SERIALIZED;
    const inDraft = !!line;
    const qty = line?.qty || 0;
    const serialCount = (line?.item_ids || []).length;

    return (
        <div
            className={`flex items-center gap-3 border-b border-border px-6 py-3${inDraft ? ' bg-primary/5' : ''}`}
            data-testid={`product-row-${draftKey(row)}`}
        >
            <div className="flex min-w-0 flex-1 flex-col gap-0.5">
                <p className="truncate text-sm font-semibold text-foreground">{row.description || row.sku}</p>
                <div className="flex items-center gap-1.5 text-[11px] text-muted">
                    <span className="font-medium">{row.sku}</span>
                    <span>•</span>
                    <span>{row.carrier_name || '-'}</span>
                    <span>•</span>
                    <span className="font-semibold">{sellableLabel(row, qty)}</span>
                </div>
            </div>
            {!inDraft ? (
                <Button variant="outline" size="sm" onClick={() => onAdd(row)}>
                    Add
                </Button>
            ) : serialized ? (
                <Badge
                    variant={serialCount > 0 ? 'success' : 'default'}
                    className={serialCount > 0 ? undefined : 'border border-border bg-surface'}
                >
                    {serialCount} selected
                </Badge>
            ) : (
                <NumberInput
                    value={qty}
                    min={0}
                    max={Number(row.on_hand_count) || 0}
                    onValueChange={(next) => onQtyChange(row, next)}
                    aria-label={`Quantity for ${row.sku}`}
                />
            )}
        </div>
    );
};

export default ProductRow;
